import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home_dev from "./routes/Home_dev";
import AboutUs_dev from "./routes/AboutUs_dev.js";
import Product_dev from "./routes/Product_dev";
import Product_dev2 from "./routes/Product_dev2";
import Product_dev3 from "./routes/Product_dev3";
import Board_dev from "./routes/Board_dev";
import Notice from "./routes/Notice";
import Home_dev_en from "./routes_en/Home_dev";
import Product_dev_en from "./routes_en/Product_dev";
import Product_dev2_en from "./routes_en/Product_dev2";
import Product_dev3_en from "./routes_en/Product_dev3";
import AboutUs_dev_en from "./routes_en/AboutUs_dev";
import Board_dev_en from "./routes_en/Board_dev";
import Download from "./routes/Download";
import Download_en from "./routes_en/Download";
import SmartoothApp from "./routes/SmartoothApp";
import Premium from "./routes/Premium";
import Video from "./routes/Video";
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home_dev />} />
        <Route path="AboutUs" element={<AboutUs_dev />} />
        <Route path="Product" element={<Product_dev />} />
        <Route path="Product2" element={<Product_dev2 />} />
        <Route path="Product3" element={<Product_dev3 />} />
        <Route path="Board" element={<Board_dev />} /> 
        <Route path="Notice" element={<Notice />} /> 
        <Route path="Home_en" element={<Home_dev_en />} />
        <Route path="Product_en" element={<Product_dev_en />} />
        <Route path="Product2_en" element={<Product_dev2_en />} />
        <Route path="Product3_en" element={<Product_dev3_en />} />
        <Route path="AboutUs_en" element={<AboutUs_dev_en />} />
        <Route path="Board_en" element={<Board_dev_en />} /> 
        <Route path="download" element={<Download />} />
        <Route path="download_en" element={<Download_en />} />
        <Route path="smartoothapp" element={<SmartoothApp />} />
        <Route path="premium" element={<Premium />} />
        <Route path="video" element={<Video />} />
      </Routes>
    </Router>
  );
}

export default App;
